(function () {
  var NAVY = '#131A2C';
  var GOLD = '#8A6B3F';

  function pinIcon(offMarket) {
    var fill = offMarket ? '#5C5850' : NAVY;
    var svg =
      '<svg width="30" height="40" viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg" class="offers-map-pin">' +
      '<path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.7 23.3 0 15 0z" fill="' + fill + '"/>' +
      '<circle cx="15" cy="15" r="6" fill="' + GOLD + '"/>' +
      '</svg>';
    return L.divIcon({
      className: 'offers-map-pin-wrap',
      html: svg,
      iconSize: [30, 40],
      iconAnchor: [15, 40],
      popupAnchor: [0, -36],
    });
  }

  function initMap(canvas) {
    if (!canvas || canvas.dataset.offersMapInitialized) return;

    var dataScript = document.querySelector(
      'script[data-offers-map-data="' + canvas.id + '"]'
    );
    if (!dataScript) return;

    var pins;
    try {
      pins = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    if (!pins || !pins.length) return;

    canvas.dataset.offersMapInitialized = 'true';

    var map = L.map(canvas, {
      scrollWheelZoom: false,
      attributionControl: true,
    });

    L.tileLayer(
      'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 18,
      }
    ).addTo(map);

    var markers = [];
    var byId = {};
    pins.forEach(function (pin) {
      var marker = L.marker([pin.lat, pin.lng], {
        icon: pinIcon(pin.offMarket),
        keyboard: true,
        alt: pin.title,
      }).addTo(map);

      var tooltipHtml =
        '<div class="offers-map-tooltip"><strong>' +
        pin.title +
        '</strong><span>' +
        pin.price +
        '</span></div>';
      marker.bindTooltip(tooltipHtml, { direction: 'top', offset: [0, -36] });

      marker.on('click', function () {
        if (pin.url) window.location.href = pin.url;
      });

      markers.push(marker);
      byId[String(pin.id)] = marker;
    });

    canvas._offersMap = { map: map, markers: markers, byId: byId, circle: null, filtered: false };
    var userMoved = false;
    function fit() {
      map.invalidateSize();
      if (markers.length === 1) {
        map.setView(markers[0].getLatLng(), 13);
      } else {
        map.fitBounds(L.featureGroup(markers).getBounds().pad(0.2));
      }
    }
    fit();
    map.on('zoomstart movestart', function (ev) { if (ev.originalEvent) userMoved = true; });
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (!userMoved && !canvas._offersMap.filtered) fit();
        else map.invalidateSize();
      }).observe(canvas);
    }
    window.addEventListener('load', function () {
      if (!userMoved && !canvas._offersMap.filtered) fit();
    });


    // Allow wheel zoom once the user interacts with the map, so page scroll isn't hijacked.
    canvas.addEventListener('click', function () {
      map.scrollWheelZoom.enable();
    });
  }

  function allBounds(markers) {
    return L.featureGroup(markers).getBounds().pad(0.2);
  }

  function onFilter(e) {
    var d = e.detail || {};
    document.querySelectorAll('[data-offers-map]').forEach(function (canvas) {
      var inst = canvas._offersMap;
      if (!inst) return;
      inst.filtered = !!d.active;
      if (inst.circle) { inst.map.removeLayer(inst.circle); inst.circle = null; }
      var ids = {};
      (d.ids || []).forEach(function (id) { ids[String(id)] = true; });
      var visible = [];
      Object.keys(inst.byId).forEach(function (id) {
        var m = inst.byId[id];
        var show = !d.active || ids[id];
        if (show) { if (!inst.map.hasLayer(m)) m.addTo(inst.map); visible.push(m); }
        else if (inst.map.hasLayer(m)) inst.map.removeLayer(m);
      });
      if (d.center && d.radiusKm) {
        inst.circle = L.circle([d.center.lat, d.center.lng], {
          radius: d.radiusKm * 1000, color: GOLD, weight: 1.5, dashArray: '6 6',
          fillColor: GOLD, fillOpacity: 0.08
        }).addTo(inst.map);
        inst.map.fitBounds(inst.circle.getBounds().pad(0.1));
      } else if (visible.length === 1) {
        inst.map.setView(visible[0].getLatLng(), 13);
      } else if (visible.length > 1) {
        inst.map.fitBounds(allBounds(visible));
      } else {
        inst.map.fitBounds(allBounds(inst.markers));
      }
    });
  }

  document.addEventListener('landora:offers-filter', onFilter);

  function initAll() {
    if (typeof L === 'undefined') return;
    document.querySelectorAll('[data-offers-map]').forEach(initMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
